// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"burger-composition-element_wrapper__2Ac_B","nameWrapper":"burger-composition-element_nameWrapper__3ukxG","costWrapper":"burger-composition-element_costWrapper__1xlXL"};